<div class="dropdown">
  <button id="{{ id }}" [class]="(altClass || 'btn btn-link') + ' dropdown-toggle'" type="button" [disabled]="disabled" tabindex="0">
    <ng-container *ngIf="model">
      {{model[labelFieldName] ? model[labelFieldName] : model || placeholder}}
    </ng-container>
    <ng-container *ngIf="!model">
      {{placeholder}}
    </ng-container>
    <i class="fa fa-caret-down"></i>
  </button>
  <ul class="menu">
    <li *ngFor="let el of elements" class="menu-item" (mousedown)="onClick(el)">
      <a>
        {{ el[labelFieldName] ? el[labelFieldName] : el }}
      </a>
    </li>
  </ul>
</div>